import { useRecoilValue } from "recoil";
import { permanentDataAtom } from "recoil/permanentDataAtom";

export default function useIsInappWebview() {
  const permanentDataState = useRecoilValue(permanentDataAtom);
  const isInappWebview = permanentDataState?.isWebview;

  return isInappWebview;
}
